import { Link } from 'react-router-dom';
import { latestUpdates } from '@/mocks/anime';

export default function LatestUpdate() {
  return (
    <section className="bg-background-100/50 py-10">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500">每日更新，追番不等待</p>
          </div>
          <span className="text-xs text-foreground-400 whitespace-nowrap">
            更新于 {new Date().toLocaleDateString('zh-CN')}
          </span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {latestUpdates.slice(0, 8).map((anime, idx) => (
            <Link
              key={anime.id}
              to={`/article/${anime.slug}`}
              className="group flex items-center gap-4 bg-background-50 border border-background-200/70 rounded-xl p-4 hover:border-primary-200 hover:bg-primary-50/10 transition-all cursor-pointer"
            >
              <span className={`font-heading text-xl w-8 shrink-0 text-center ${
                idx < 3 ? 'text-primary-500' : 'text-foreground-400'
              }`}>
                {idx + 1}
              </span>
              <div className="w-14 h-18 rounded-lg overflow-hidden shrink-0">
                <img
                  src={anime.cover}
                  alt={anime.title}
                  title={`${anime.title} - 51动漫网`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors line-clamp-1">
                  {anime.title}
                </h3>
                <div className="flex flex-wrap items-center gap-2 mt-1">
                  <span className="text-xs text-foreground-400">{anime.updateChapter}</span>
                  <span className="text-xs px-2 py-0.5 bg-accent-100 text-accent-700 rounded-full whitespace-nowrap">
                    {anime.categories[0]}
                  </span>
                </div>
              </div>
              <div className="text-right shrink-0 hidden sm:block">
                <span className="text-xs text-foreground-400">{anime.updateTime}</span>
                <div className="text-xs text-foreground-500 mt-1">
                  {(anime.views / 10000).toFixed(0)}万 阅读
                </div>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-primary-500 transition-colors shrink-0"></i>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}